import { Component } from '@angular/core';

@Component({
  selector: 'app-em-construcao',
  templateUrl: './em-construcao.component.html',
  styleUrls: ['./em-construcao.component.scss']
})
export class EmConstrucaoComponent {
  // Componente simples, sem lógica adicional necessária no momento
} 